import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { ScanRunState } from "types/generated";
import { AccessResult, hasAtLeastWriteAccess, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const SCAN_IN_PROGRESS_STATES = new Set([ScanRunState.Queued, ScanRunState.Scanning]);

export const SCAN_IN_PROGRESS_MESSAGE = "A scan is already in progress";

export const isScanRunInProgress = (state?: ScanRunState | null) =>
  !!state && SCAN_IN_PROGRESS_STATES.has(state);

type ScanForTrigger = {
  space: { id: string };
  latestRun?: { state: ScanRunState } | null;
};

const useCanTriggerScan = (): ((scan?: ScanForTrigger) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (scan?: ScanForTrigger) => {
      if (!scan) {
        return { result: false };
      }

      if (viewer.admin || hasAtLeastWriteAccess(viewer, scan.space.id)) {
        if (isScanRunInProgress(scan.latestRun?.state)) {
          return { result: false, message: SCAN_IN_PROGRESS_MESSAGE };
        }

        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanTriggerScan;
